<div class="row no-gutters">

    <div class="col-12 offset-lg-1 col-lg-10">

        <div class="row">
            <div class="col-12 col-lg-9">
                <span class="basic-content-title">
                    Informações sobre a situação
                    patrimonial e financeira</span>
                <app-spacer [bottom]="48"></app-spacer>
            </div>
        </div>

        <app-signup-unified-person-income-realty></app-signup-unified-person-income-realty>
        <app-spacer [bottom]="70"></app-spacer>

        <div class="row">
            <div class="col-12 col-lg-9">
                <span class="section-title">
                    Outros Bens e Direitos, inclusive
                    aplicações financeiras
                </span>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <app-signup-unified-person-income-others></app-signup-unified-person-income-others>
        <app-spacer [bottom]="70"></app-spacer>

        <form [formGroup]="form">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <app-currency-input [group]="form" controlName="wage"
                        label="Salário/Pró labore" mask="separator.2"
                        placeholder="R$ 00.000,00">
                    </app-currency-input>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <div class="col-12 col-lg-6">
                    <app-currency-input [group]="form"
                        controlName="other_income" label="Outros Rendimentos"
                        mask="separator.2" placeholder="R$ 00.000,00">
                    </app-currency-input>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>
        </form>

    </div>
</div>